import React, { Component } from "react";
import crStyles from "../customerReservation/crStyles";
import styles from "../tradeIn/TradeIn.module.scss";
import sharedStyles from "../customerOrderDetail/orderDetailsNewVersion/OrderDetailsNewVersion.module.scss";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { withTranslation } from "react-i18next";
import {
  OFFLINE_TRADE_IN_MARKETS,
  ONLINE_TRADE_IN_MARKETS,
} from "../../utils/EmpUtil";
import { FINANCED, LEASED, OWNED } from "../../common/Constants";
import OfflineTradeIn from "./offline/OfflineTradeIn";
import OnlineTradeIn from "./online/OnlineTradeIn";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../shared/ExpansionPanels/ExpansionPanel";
import SharedToolTip from "../../shared/sharedToolTip/SharedToolTip";

class TradeIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandTradeInDetails: false,
      tradeInToolTipOpen: false,
    };
  }

  toggleTradeInToolTip = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      tradeInToolTipOpen: !prevState.tradeInToolTipOpen,
    }));
  };

  expandCollapseAccordion = () =>
    this.setState((prevState) => ({
      expandTradeInDetails: !prevState.expandTradeInDetails,
    }));

  getTradeInType = (type) => {
    switch (type) {
      case FINANCED:
        return this.props.t("TradeIn.US.finance");
      case LEASED:
        return this.props.t("TradeIn.US.lease");
      case OWNED:
        return this.props.t("TradeIn.US.owned");
      default:
        return null;
    }
  };

  render() {
    const market = this.props.fromCrc
      ? this.props.selectedMarket
      : this.props.user.market;

    const tradeInType =
      this.props.tradeInDetails &&
      this.getTradeInType(this.props.tradeInDetails.ownershipType);

    let tradeInHeader = this.props.t("TradeIn.header");

    if (tradeInType) {
      tradeInHeader = `${tradeInHeader} - ${tradeInType}`;
    }

    return (
      <StyledBasicExpansionPanel
        defaultExpanded={false}
        onChange={this.expandCollapseAccordion}
      >
        <StyledBasicExpansionPanelSummary style={crStyles.headerBarNeutral}>
          <div className={sharedStyles.headerBar}>
            <div className={sharedStyles.boldHeaderWithToolTip}>
              {tradeInHeader}
              <SharedToolTip
                openTestid="tradeInToolTipOpen"
                open={this.state.tradeInToolTipOpen}
                closeTooltip={this.toggleTradeInToolTip}
                openTooltip={this.toggleTradeInToolTip}
                body={this.props.t("TradeIn.toolTip")}
              />
            </div>
            <div className={styles.acceptRejectDiv}>
              {this.state.expandTradeInDetails ? (
                <ExpandLessIcon data-testid="less" />
              ) : (
                <ExpandMoreIcon data-testid="more" />
              )}
            </div>
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>

        <div className={styles.bottomBorder}></div>

        {this.props.isOrderCancelled(this.props.status) && (
          <div className={this.props.overlay} data-testid="tradeInOverlay" />
        )}

        {ONLINE_TRADE_IN_MARKETS.includes(market) && (
          <OnlineTradeIn {...this.props} market={market} />
        )}
        {OFFLINE_TRADE_IN_MARKETS.includes(market) && (
          <OfflineTradeIn {...this.props} />
        )}
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(TradeIn);
